<div class="form-group">
  <input type="file"
         class="form-control"
         id="uploaderFile"
         [multiple]="queueLimit > 1"
         ng2FileSelect
         #fileUploadBtn
         [accept]="accept ? accept : '.png,.gif,.jpg,.xls,.xlsx,.doc,.docx,.pdf'"
         [uploader]="uploader">
  <span>{{ label }}</span>
  <div ng2FileDrop
       [uploader]="uploader"
       class="well my-drop-zone">
    <p>{{ 'admin.service_request.drag_and_drop' | translate }}</p>
    <button type="button" (click)="fileUploadBtn.click()" class="btn btn-primary">
      {{ 'admin.service_request.browse_files' | translate }}
    </button>
  </div>
  <small id="file-validation">
    {{ description }}
  </small>
  <table class="table" *ngIf="uploader?.queue?.length || firstModel?.length || uploadedItems?.length">
    <thead>
    <tr>
      <th width="50%">{{'doctrine.file.name' | translate}}</th>
      <th width="200px">{{'doctrine.file.size' | translate}}</th>
      <th>{{'global.status' | translate}}</th>
      <th width="100px">{{'global.action' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of firstModel; let index=index">
      <td><strong>{{ item?.filename }}</strong></td>
      <td nowrap>{{ item?.fileSize / 1024 / 1024 | number:'.2' }} MB</td>
      <td>
        <span><i class="fa fa-lg fa-check text-success"></i></span>
      </td>
      <td nowrap>
        <a (click)="remove(index)">
          <i class="fa fa-lg fa-trash text-danger"></i>
        </a>
      </td>
    </tr>
    <tr *ngFor="let item of uploadedItems; let index=index">
      <td><strong>{{ item?.filename }}</strong></td>
      <td nowrap>{{ item?.fileSize / 1024 / 1024 | number:'.2' }} MB</td>
      <td>
        <span><i class="fa fa-lg fa-check text-success"></i></span>
      </td>
      <td nowrap>
        <a (click)="removeUploaded(index)">
          <i class="fa fa-lg fa-trash text-danger"></i>
        </a>
      </td>
    </tr>
    <tr *ngFor="let item of uploader.queue">
      <td><strong>{{ item?.file?.name }}</strong></td>
      <td nowrap>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</td>
      <td *ngIf="item.isUploading">
        <div class="progress" style="margin-bottom: 0;">
          <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
        </div>
      </td>
      <td *ngIf="item.isUploaded">
        <span *ngIf="item.isSuccess"><i class="fa fa-lg fa-check text-success"></i></span>
        <span *ngIf="item.isError"><i class="fa fa-lg fa-times text-danger"></i></span>
      </td>
      <td nowrap>
        <a (click)="stop(item)">
          <i class="fa fa-lg fa-trash text-danger"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
